/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  DeleteAdminV1StoresStoreIdPoliciesIdPathParameters,
  GetAdminV1StoresStoreIdPolicies200,
  GetAdminV1StoresStoreIdPoliciesIdPathParameters,
  GetAdminV1StoresStoreIdPoliciesPathParameters,
  PatchAdminV1StoresStoreIdPoliciesIdBody,
  PatchAdminV1StoresStoreIdPoliciesIdPathParameters,
  Policy,
  PostAdminV1StoresStoreIdPoliciesBody,
  PostAdminV1StoresStoreIdPoliciesPathParameters
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Bounded at 50 per store, so the whole list comes back at once
 * @summary Every policy document of the store, in footer order
 */
export const getAdminV1StoresStoreIdPolicies = (
    { storeId }: GetAdminV1StoresStoreIdPoliciesPathParameters,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdPolicies200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdPolicies200>(
      {url: `/admin/v1/stores/${storeId}/policies`, method: 'GET'
    },
      options);
    }
  /**
 * One document per kind except `custom`; the handle defaults to the kind. `resolvedSeo` shows what the storefront will render and its warnings
 * @summary Create a policy document
 */
export const postAdminV1StoresStoreIdPolicies = (
    { storeId }: PostAdminV1StoresStoreIdPoliciesPathParameters,
    postAdminV1StoresStoreIdPoliciesBody: BodyType<PostAdminV1StoresStoreIdPoliciesBody>,
 options?: SecondParameter<typeof customInstance<Policy>>,) => {
      return customInstance<Policy>(
      {url: `/admin/v1/stores/${storeId}/policies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdPoliciesBody
    },
      options);
    }
  /**
 * @summary One policy document
 */
export const getAdminV1StoresStoreIdPoliciesId = (
    { storeId, id }: GetAdminV1StoresStoreIdPoliciesIdPathParameters,
 options?: SecondParameter<typeof customInstance<Policy>>,) => {
      return customInstance<Policy>(
      {url: `/admin/v1/stores/${storeId}/policies/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update a policy; renaming a published one writes a 301
 */
export const patchAdminV1StoresStoreIdPoliciesId = (
    { storeId, id }: PatchAdminV1StoresStoreIdPoliciesIdPathParameters,
    patchAdminV1StoresStoreIdPoliciesIdBody: BodyType<PatchAdminV1StoresStoreIdPoliciesIdBody>,
 options?: SecondParameter<typeof customInstance<Policy>>,) => {
      return customInstance<Policy>(
      {url: `/admin/v1/stores/${storeId}/policies/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAdminV1StoresStoreIdPoliciesIdBody
    },
      options);
    }
  /**
 * @summary Delete a policy document
 */
export const deleteAdminV1StoresStoreIdPoliciesId = (
    { storeId, id }: DeleteAdminV1StoresStoreIdPoliciesIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/policies/${id}`, method: 'DELETE'
    },
      options);
    }
  export type GetAdminV1StoresStoreIdPoliciesResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdPolicies>>>
export type PostAdminV1StoresStoreIdPoliciesResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdPolicies>>>
export type GetAdminV1StoresStoreIdPoliciesIdResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdPoliciesId>>>
export type PatchAdminV1StoresStoreIdPoliciesIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdPoliciesId>>>
export type DeleteAdminV1StoresStoreIdPoliciesIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdPoliciesId>>>
